import { useContext, useEffect, useState } from 'react'
import { UgeEditorContext } from '../../contexts/editor'
import { stickerCategories } from '../../types/sticker-category'
import { Checkerboard } from '../style'
import Grid from './grid'
import Navigation from './navigation'

const StickersEditor = () => {
    const { activeEditorProps, resetEditorProps } = useContext(UgeEditorContext)
    const [searchTerm, setSearchTerm] = useState<string>(activeEditorProps?.searchTerm || stickerCategories[0])

    useEffect(() => {
        if (activeEditorProps?.searchTerm) {
            setSearchTerm(activeEditorProps.searchTerm)
            resetEditorProps()
        }
    }, [activeEditorProps?.searchTerm])

    return (
        <Checkerboard>
            <Navigation searchTerm={searchTerm} onSearch={setSearchTerm} />
            {searchTerm && <Grid searchTerm={searchTerm} />}
        </Checkerboard>
    )
}

export default StickersEditor
